import { tick } from './haptic'
import { el } from './ui'

// A switch between the views of one page, in the look of the Diary's Day · Week · Month (Liam, 9 Oct 2026: switching
// "could be more satisfying"): the lemon slides and settles with a small bounce, the phone gives a light tap
// (haptic.ts), and the page slides the new view in from the side tapped (the caller, from `dir`). The Diary's own switch
// (month.ts threeViewSwitch) redraws its whole screen and carries the slide across that redraw; a page that only shows
// and hides its views needs none of that, so this is its sibling, sharing the look (styles.css .lemon-switch) and none
// of its state. Used by the customer page's Visits · Details · Analysis.
// choose(key): the same move made by the page itself (a shortcut elsewhere on it), without the phone's tap.
export function lemonSwitch<K extends string>(label: string, views: readonly { key: K; text: string }[], current: K, pick: (key: K, dir: number) => void): HTMLElement & { choose: (key: K) => void } {
  const seg = el('div', { class: 'lemon-switch', role: 'group', 'aria-label': label })
  seg.setAttribute('style', `--lemon-count: ${views.length}`)
  const thumb = el('span', { class: 'lemon-switch-thumb', 'aria-hidden': 'true' })
  const at = (i: number): void => { thumb.style.transform = `translateX(${i * 100}%)` }
  let index = Math.max(0, views.findIndex((v) => v.key === current))
  at(index)
  seg.append(thumb)
  const buttons: HTMLElement[] = []
  const move = (i: number): void => {
    const dir = i - index
    index = i
    buttons.forEach((other, j) => other.setAttribute('aria-pressed', String(j === i)))
    at(i)
    pick(views[i].key, dir)
  }
  views.forEach((v, i) => {
    const b = el('button', { type: 'button', 'aria-pressed': String(i === index), 'data-view': v.key }, v.text)
    b.addEventListener('click', () => {
      if (i === index) return
      tick()
      move(i)
    })
    buttons.push(b)
    seg.append(b)
  })
  return Object.assign(seg, { choose: (key: K): void => { const i = views.findIndex((v) => v.key === key); if (i >= 0 && i !== index) move(i) } })
}
